/* WEP reusable sections – behaviour
   Reveal on scroll, count-up stats, before/after demos, growth chart, X-ray scan,
   FAQ tabs + accordion, and forms that post to the Podio lead script. */
(function () {
  'use strict';
  if (window.WEPSections) return;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var params = new URLSearchParams(location.search);
  var still = reduce || params.has('wep-static');

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function once(el, key) { if (el['_wep' + key]) return false; el['_wep' + key] = true; return true; }

  /* ---------- number tween ---------- */
  function fmt(el, v) {
    var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var n = Number(v).toFixed(dec);
    if (el.hasAttribute('data-comma')) n = Number(n).toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    return (el.getAttribute('data-prefix') || '') + n + (el.getAttribute('data-suffix') || '');
  }
  function tween(el, a, b, dur) {
    if (still) { el.textContent = fmt(el, b); return; }
    var s = performance.now();
    (function step(now) {
      var p = Math.min(1, (now - s) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(el, a + (b - a) * e);
      if (p < 1) requestAnimationFrame(step);
    })(s);
  }

  /* ---------- reveal + count-up ---------- */
  function countUp(el) {
    var m = el.textContent.trim().match(/^([\d.,]+)(.*)$/);
    if (!m || still) return;
    var raw = m[1].replace(/,/g, ''), end = parseFloat(raw), dec = raw.indexOf('.') > -1 ? 1 : 0, suf = m[2], s = performance.now();
    (function g(now) {
      var p = Math.min(1, (now - s) / 1200), e = 1 - Math.pow(1 - p, 3);
      el.textContent = (end * e).toFixed(dec) + suf;
      if (p < 1) requestAnimationFrame(g);
    })(s);
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = e.target;
      if (t.classList.contains('wep-rv')) {
        var sib = t.parentElement ? $$(':scope > .wep-rv', t.parentElement) : [];
        var i = sib.indexOf(t);
        if (i > 0 && !reduce) t.style.transitionDelay = Math.min(i, 6) * 70 + 'ms';
        t.classList.add('is-in');
      }
      if (t.hasAttribute('data-wep-count')) countUp(t);
      io.unobserve(t);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }) : null;

  function initReveal(root) {
    $$('.wep-rv, [data-wep-count]', root).forEach(function (el) {
      if (!once(el, 'rv')) return;
      if (io && !document.documentElement.classList.contains('shopify-design-mode')) io.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* ---------- before / after demos ---------- */
  function initDemo(root) {
    if (!once(root, 'demo')) return;
    var hold = parseInt(root.getAttribute('data-hold') || '5400', 10);
    var btns = $$('[data-state]', root);
    var items = $$('[data-before]', root);           // positioned / ordered items
    var list = root.querySelector('[data-slots]');   // container of positioned items
    var mode = list ? list.getAttribute('data-slots') : '';
    var nums = $$('[data-to]', root);
    var swaps = $$('[data-after-text]', root);
    var typer = root.querySelector('[data-type]');
    var fullQ = typer ? typer.textContent : '';
    var state = 'before', paused = false, t0 = performance.now();

    swaps.forEach(function (el) { el.setAttribute('data-before-text', el.textContent); });

    function slotOf(el) { return parseInt(el.getAttribute('data-' + state), 10); }
    function layout() {
      if (!list) return;
      if (mode === 'stack') {                         // absolutely positioned rows (SERP)
        var slot = parseFloat(getComputedStyle(list).getPropertyValue('--slot')) || 104;
        if (String(getComputedStyle(list).getPropertyValue('--slot')).indexOf('rem') > -1) slot = slot * 10;
        var first = items[0];
        if (first) { var h = first.offsetHeight; if (h) slot = h + 10; }
        var visible = parseInt(list.getAttribute('data-visible') || '3', 10);
        items.forEach(function (el) {
          var k = slotOf(el);
          el.style.transform = 'translateY(' + ((k < 0 ? visible : k) * slot) + 'px)';
          el.style.opacity = (k < 0 || k >= visible) ? 0 : 1;
        });
      } else {                                        // grid order (Shopping)
        items.slice().sort(function (a, b) { return slotOf(a) - slotOf(b); }).forEach(function (el) {
          list.appendChild(el);
          el.classList.toggle('is-hidden', slotOf(el) < 0);
        });
        if (!still) { root.classList.remove('is-anim'); void root.offsetWidth; root.classList.add('is-anim'); }
      }
    }
    function typeQ() {
      if (!typer || still) return;
      var i = 0; typer.textContent = '';
      var iv = setInterval(function () { typer.textContent = fullQ.slice(0, ++i); if (i >= fullQ.length) clearInterval(iv); }, 34);
    }
    function set(n) {
      state = n; t0 = performance.now();
      root.classList.toggle('is-after', n === 'after');
      btns.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-state') === n); b.setAttribute('aria-pressed', b.getAttribute('data-state') === n); });
      layout();
      swaps.forEach(function (el) { el.textContent = el.getAttribute(n === 'after' ? 'data-after-text' : 'data-before-text'); });
      nums.forEach(function (el) {
        var a = parseFloat(el.getAttribute('data-from')), b = parseFloat(el.getAttribute('data-to'));
        if (n === 'after') tween(el, a, b, 1500); else el.textContent = fmt(el, a);
      });
      if (n === 'before') typeQ();
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-state')); }); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; t0 = performance.now(); });
    window.addEventListener('resize', layout);

    if (still) { set('after'); return; }
    set('before');
    var bars = { before: root.querySelector('[data-state="before"] .wep-prog'), after: root.querySelector('[data-state="after"] .wep-prog') };
    (function tick(now) {
      if (!root.isConnected) return;
      var p = Math.min(1, (now - t0) / hold);
      var on = bars[state], off = bars[state === 'before' ? 'after' : 'before'];
      if (on) on.style.transform = 'scaleX(' + p + ')';
      if (off) off.style.transform = 'scaleX(0)';
      if (!paused && p >= 1) set(state === 'before' ? 'after' : 'before');
      requestAnimationFrame(tick);
    })(t0);
  }


  /* ---------- AI answer demo (AI SEO page hero) ---------- */
  function initAi(root) {
    if (!once(root, 'ai')) return;
    var hold = parseInt(root.getAttribute('data-hold') || '5200', 10);
    var scenes = $$('[data-scene-i]', root), tabs = $$('[data-scene]', root), segs = $$('[data-ai-state]', root), nums = $$('[data-to]', root);
    var cur = 0, state = 'before', paused = false, t0 = performance.now(), typing = null, thinkT = null, numT = null;
    function type(i) {
      var el = scenes[i] && scenes[i].querySelector('[data-q]');
      if (!el) return;
      var full = el.getAttribute('data-full') || el.textContent; el.setAttribute('data-full', full);
      clearInterval(typing);
      if (still) { el.textContent = full; return; }
      var k = 0; el.textContent = '';
      typing = setInterval(function () { el.textContent = full.slice(0, ++k); if (k >= full.length) clearInterval(typing); }, 26);
    }
    function show(i) {
      cur = i;
      scenes.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      tabs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-selected', k === i); });
    }
    function set(n) {
      state = n; t0 = performance.now();
      root.classList.toggle('is-after', n === 'after');
      segs.forEach(function (b) { var on = b.getAttribute('data-ai-state') === n; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
      var q = scenes[cur] && scenes[cur].querySelector('[data-q]');
      var qlen = q ? (q.getAttribute('data-full') || q.textContent).length : 40;
      var think = still ? 0 : (n === 'before' ? qlen * 26 + 700 : 1100);
      clearTimeout(thinkT); clearTimeout(numT);
      if (think) { root.classList.add('is-thinking'); thinkT = setTimeout(function () { root.classList.remove('is-thinking'); }, think); }
      else root.classList.remove('is-thinking');
      nums.forEach(function (el) { el.textContent = fmt(el, parseFloat(el.getAttribute('data-from'))); });
      if (n === 'after') numT = setTimeout(function () {
        nums.forEach(function (el) { tween(el, parseFloat(el.getAttribute('data-from')), parseFloat(el.getAttribute('data-to')), 1400); });
      }, think);
      if (n === 'before') type(cur);
    }
    tabs.forEach(function (b, k) { b.addEventListener('click', function () { show(k); set('before'); }); });
    segs.forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-ai-state')); }); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; t0 = performance.now(); });
    show(0);
    if (still) { set('after'); return; }
    set('before');
    var bars = { before: root.querySelector('[data-ai-state="before"] .wep-prog'), after: root.querySelector('[data-ai-state="after"] .wep-prog') };
    (function tick(now) {
      if (!root.isConnected) return;
      var p = Math.min(1, (now - t0) / hold);
      var on = bars[state], off = bars[state === 'before' ? 'after' : 'before'];
      if (on) on.style.transform = 'scaleX(' + p + ')';
      if (off) off.style.transform = 'scaleX(0)';
      if (!paused && p >= 1) {
        if (state === 'before') set('after');
        else { show((cur + 1) % scenes.length); set('before'); }
      }
      requestAnimationFrame(tick);
    })(t0);
  }

  /* ---------- Amazon PPC: search term cleanup (hero) ---------- */
  function initStc(root) {
    if (!once(root, 'stc')) return;
    var rows = $$('[data-stc-row]', root), nums = $$('[data-g-to]', root);
    function fmt(v, e) { return (e.getAttribute('data-g-pre') || '') + Math.round(v) + (e.getAttribute('data-g-suf') || ''); }
    function setK(p) { nums.forEach(function (e) { var a = +e.getAttribute('data-g-from'), b = +e.getAttribute('data-g-to'); e.textContent = fmt(a + (b - a) * p, e); }); }
    if (still) { rows.forEach(function (r) { r.classList.add('is-done'); }); return; }
    root.classList.add('is-ready'); setK(0);
    function play() {
      var STEP = 750, t0 = 600;
      rows.forEach(function (r, i) {
        setTimeout(function () { r.classList.add('is-active'); }, t0 + i * STEP);
        setTimeout(function () { r.classList.remove('is-active'); r.classList.add('is-done'); setK((i + 1) / rows.length); }, t0 + i * STEP + 420);
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); play(); } }, { threshold: 0.3 });
      io.observe(root);
    } else play();
  }

  /* ---------- Amazon PPC: break-even ACoS calculator ---------- */
  function initBeacos(root) {
    if (!once(root, 'beacos')) return;
    var inp = {}; $$('[data-bc]', root).forEach(function (i) { inp[i.getAttribute('data-bc')] = i; });
    var out = {}; $$('[data-bc-out]', root).forEach(function (o) { out[o.getAttribute('data-bc-out')] = o; });
    var fill = root.querySelector('[data-bc-fill]'), mark = root.querySelector('[data-bc-mark]'), warn = root.querySelector('[data-bc-warn]');
    function num(k) { var v = parseFloat(inp[k] && inp[k].value); return isFinite(v) && v > 0 ? v : 0; }
    function pct(v) { return Math.round(v) + '%'; }
    function calc() {
      var price = num('price'), profit = price - num('cost') - num('fees') - num('other');
      var be = price > 0 ? Math.max(0, profit / price * 100) : 0;
      out.be.textContent = price > 0 ? pct(be) : '—';
      out.profit.textContent = (profit < 0 ? '−$' : '$') + Math.abs(profit).toFixed(2);
      var bad = price > 0 && profit <= 0;
      if (warn) warn.hidden = !bad;
      out.launch.textContent = bad ? '—' : pct(be);
      out.grow.textContent = bad ? '—' : pct(be * 0.8);
      out.profit2.textContent = bad ? '—' : pct(be * 0.6);
      var w = Math.min(100, be); if (fill) fill.style.width = w + '%'; if (mark) mark.style.left = 'calc(' + w + '% - 1px)';
    }
    Object.keys(inp).forEach(function (k) { inp[k].addEventListener('input', calc); });
    calc();
  }

  /* ---------- Growth graph (Google Ads page hero) ---------- */
  function initGrowth(root) {
    if (!once(root, 'growth')) return;
    var nums = $$('[data-g-to]', root), D = 3600, LOOP = 10000, paused = false, timer = null, raf = null;
    function fmt(v, e) {
      var d = parseInt(e.getAttribute('data-g-dec') || '0', 10);
      return (e.getAttribute('data-g-pre') || '') + v.toFixed(d) + (e.getAttribute('data-g-suf') || '');
    }
    function setAll(p) {
      nums.forEach(function (e) { var a = +e.getAttribute('data-g-from'), b = +e.getAttribute('data-g-to'); e.textContent = fmt(a + (b - a) * p, e); });
    }
    if (still) { root.classList.add('is-static', 'is-play', 'is-done'); setAll(1); return; }
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    function run() {
      cancelAnimationFrame(raf);
      root.classList.remove('is-play', 'is-done'); setAll(0);
      void root.offsetWidth;
      root.classList.add('is-play');
      var t0 = performance.now();
      (function step(t) {
        var p = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - p, 3);
        setAll(e);
        if (p < 1) raf = requestAnimationFrame(step); else root.classList.add('is-done');
      })(t0);
      timer = setTimeout(function wait() { if (paused) { timer = setTimeout(wait, 600); return; } run(); }, LOOP);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); run(); } }, { threshold: 0.3 });
      io.observe(root);
    } else run();
  }

  /* ---------- Meta ads phone (Facebook Ads page hero) ---------- */
  /* Hero before/after slider: sweeps from the old homepage to the new one, then the next client; drag, dots and reduced motion supported. */
  function initBA(wrap) {
    if (!once(wrap, 'ba')) return;
    var canvas = wrap.querySelector('.wep-ba__canvas'), range = wrap.querySelector('.wep-ba__range'),
        slides = $$('.wep-ba__slide', wrap), dots = $$('.wep-ba__dot', wrap),
        tag = wrap.querySelector('[data-ba-tag]'), url = wrap.querySelector('[data-ba-url]'), nm = wrap.querySelector('[data-ba-name]');
    if (!canvas || !range || !slides.length) return;
    var cur = 0, x = 100, timer = null, raf = null, paused = false, resume = null;
    function setX(v) {
      x = +v; canvas.style.setProperty('--x', x + '%'); range.value = x;
      var s = slides[cur], after = x < 50;
      tag.textContent = after ? 'After · Today' : 'Before · ' + s.getAttribute('data-year');
      tag.classList.toggle('is-after', after);
    }
    function show(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === cur); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); });
      url.textContent = slides[cur].getAttribute('data-url'); nm.textContent = slides[cur].getAttribute('data-name');
      setX(100);
    }
    function stopAll() { clearTimeout(timer); cancelAnimationFrame(raf); }
    function sweep(done) {
      var t0 = null, from = 100, to = 0, dur = 2000;
      (function step(ts) {
        if (paused) return;
        if (!t0) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1), e = p < .5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
        setX(from + (to - from) * e);
        if (p < 1) raf = requestAnimationFrame(step); else done();
      })(performance.now());
    }
    function play() {
      if (still || paused) return;
      stopAll();
      timer = setTimeout(function () {            /* hold the old design */
        sweep(function () {                        /* old -> new */
          timer = setTimeout(function () { show(cur + 1); play(); }, 2600);   /* hold new, next client */
        });
      }, 1600);
    }
    function pause() { paused = true; stopAll(); clearTimeout(resume); }
    function later() { clearTimeout(resume); resume = setTimeout(function () { paused = false; if (x < 50) { timer = setTimeout(function () { show(cur + 1); play(); }, 1500); } else { play(); } }, 6000); }
    range.addEventListener('input', function () { pause(); setX(range.value); });
    range.addEventListener('change', later);
    dots.forEach(function (d) { d.addEventListener('click', function () { stopAll(); paused = false; show(+d.getAttribute('data-i')); play(); }); });
    wrap.addEventListener('mouseenter', function () { if (!still) { paused = true; stopAll(); } });
    wrap.addEventListener('mouseleave', function () { if (!still && !resume) { paused = false; } if (!still) { paused = false; if (x < 50) { timer = setTimeout(function () { show(cur + 1); play(); }, 1200); } else { play(); } } });
    show(0);
    if (still) { setX(50); return; }
    play();
  }

  /* Product page hotspots: hovering or focusing a numbered point highlights the matching dot on the layout panel. */
  function initHL(list) {
    if (!once(list, 'hl')) return;
    var scope = list.closest('.wep-split__grid') || document;
    $$('li[data-hl]', list).forEach(function (li) {
      var hot = scope.querySelector('[data-hot="' + li.getAttribute('data-hl') + '"]');
      if (!hot) return;
      function on() { hot.classList.add('is-on'); li.classList.add('is-on'); }
      function off() { hot.classList.remove('is-on'); li.classList.remove('is-on'); }
      li.addEventListener('mouseenter', on); li.addEventListener('mouseleave', off);
      li.addEventListener('focus', on); li.addEventListener('blur', off);
    });
  }

  function initMeta(root) {
    if (!once(root, 'meta')) return;
    var scenes = $$('[data-ms]', root), tabs = $$('[data-mtab]', root), camps = $$('[data-mc]', root), nums = $$('[data-g-to]', root);
    var map = [0, 1, 2], cur = 0, paused = false, timer = null, HOLD = 4200;
    function fmt(v, e) { var d = parseInt(e.getAttribute('data-g-dec') || '0', 10); return (e.getAttribute('data-g-pre') || '') + v.toFixed(d) + (e.getAttribute('data-g-suf') || ''); }
    function setNums(p) { nums.forEach(function (e) { var a = +e.getAttribute('data-g-from'), b = +e.getAttribute('data-g-to'); e.textContent = fmt(a + (b - a) * p, e); }); }
    function show(i) {
      cur = i;
      scenes.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      tabs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-pressed', k === i); });
      camps.forEach(function (c, k) { c.classList.toggle('is-on', k === map[i]); });
      root.classList.remove('is-cycle'); void root.offsetWidth; root.classList.add('is-cycle');
    }
    function count() {
      var t0 = performance.now(), D = 2600;
      (function step(t) { var p = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - p, 3); setNums(e); if (p < 1) requestAnimationFrame(step); else root.classList.add('is-done'); })(t0);
    }
    function loop() { clearTimeout(timer); timer = setTimeout(function next() { if (paused) { timer = setTimeout(next, 500); return; } show((cur + 1) % scenes.length); loop(); }, HOLD); }
    tabs.forEach(function (b, k) { b.addEventListener('click', function () { show(k); if (!still) loop(); }); });
    if (still) { root.classList.add('is-static', 'is-done'); setNums(1); show(0); return; }
    root.addEventListener('mouseenter', function () { paused = true; root.classList.add('is-paused'); });
    root.addEventListener('mouseleave', function () { paused = false; root.classList.remove('is-paused'); });
    function start() { show(0); count(); loop(); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); start(); } }, { threshold: 0.3 });
      io.observe(root);
    } else start();
  }

  /* ---------- Envelope flow hero (Email & SMS page) ---------- */
  function initEnv(root) {
    if (!once(root, 'env')) return;
    var flows = $$('[data-ef]', root), tabs = $$('[data-etab]', root), nums = $$('.wep-env__kpis [data-g-to]', root);
    var cur = 0, run = 0, paused = false, timers = [], STEP = 750;
    function fmtK(v, e) { var d = parseInt(e.getAttribute('data-g-dec') || '0', 10); return (e.getAttribute('data-g-pre') || '') + v.toFixed(d) + (e.getAttribute('data-g-suf') || ''); }
    function setK(p) { nums.forEach(function (e) { var a = +e.getAttribute('data-g-from'), b = +e.getAttribute('data-g-to'); e.textContent = fmtK(a + (b - a) * p, e); }); }
    function countK() { var t0 = performance.now(), D = 2400; (function st(t) { var p = Math.min(1, (t - t0) / D), e = 1 - Math.pow(1 - p, 3); setK(e); if (p < 1) requestAnimationFrame(st); else root.classList.add('is-done'); })(t0); }
    function clear() { timers.forEach(clearTimeout); timers = []; }
    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    function bump(el) {
      var c = el.querySelector('[data-n]'); if (!c) return;
      var n = +c.getAttribute('data-n') + 1; c.setAttribute('data-n', n);
      c.textContent = n.toLocaleString('en-US') + (c.getAttribute('data-suf') || '');
    }
    function moveDot(f, el, side) {
      var dot = f.querySelector('.wep-env__dot');
      var y = el.offsetTop + el.offsetHeight / 2, x = 21;
      if (side) { x = side.offsetLeft + side.offsetWidth / 2; y = el.offsetTop + side.offsetTop + side.offsetHeight / 2; }
      dot.style.top = y + 'px'; dot.style.left = x + 'px'; dot.style.opacity = 1;
    }
    function show(i) {
      cur = i; run = 0;
      flows.forEach(function (f, k) { f.classList.toggle('is-on', k === i); });
      tabs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-pressed', k === i); });
      root.classList.remove('is-cycle'); void root.offsetWidth; root.classList.add('is-cycle');
    }
    function play() {
      clear();
      var f = flows[cur], steps = $$('[data-step]', f), yes = run % 2 === 0, t = 300;
      var splitAt = steps.findIndex(function (s) { return s.getAttribute('data-step') === 'split'; });
      var path = yes ? steps.slice(0, splitAt + 1) : steps;
      var dot = f.querySelector('.wep-env__dot');
      dot.style.transition = 'none'; dot.style.opacity = 0; moveDot(f, steps[0]); dot.style.opacity = 0;
      void dot.offsetWidth; dot.style.transition = '';
      steps.forEach(function (s) { s.classList.remove('is-hit', 'is-pop'); });
      $$('.wep-env__yes', f).forEach(function (y) { y.classList.remove('is-pop'); });
      path.forEach(function (s, idx) {
        later(function () {
          if (paused) return;
          moveDot(f, s);
          var kind = s.getAttribute('data-step');
          if (kind !== 'wait' && kind !== 'split') { s.classList.add('is-hit'); bump(s); later(function () { s.classList.remove('is-hit'); }, STEP * 1.6); }
          if (kind === 'win') { s.classList.add('is-pop'); }
        }, t + idx * STEP);
      });
      var end = t + path.length * STEP;
      if (yes) {
        var sp = steps[splitAt], y = sp.querySelector('[data-yes]');
        later(function () { moveDot(f, sp, y); y.classList.add('is-pop'); bump(f.querySelector('[data-step="win"]')); }, end);
        end += STEP * 1.4;
      } else end += STEP * 1.2;
      later(function () {
        run += 1;
        if (run >= 2) { show((cur + 1) % flows.length); }
        play();
      }, end + 600);
    }
    tabs.forEach(function (b, k) { b.addEventListener('click', function () { show(k); if (!still) play(); }); });
    if (still) {
      root.classList.add('is-static', 'is-done'); setK(1);
      var f0 = flows[0], s0 = $$('[data-step]', f0); moveDot(f0, s0[3]);
      return;
    }
    root.addEventListener('mouseenter', function () { paused = true; root.classList.add('is-paused'); });
    root.addEventListener('mouseleave', function () { if (!paused) return; paused = false; root.classList.remove('is-paused'); play(); });
    root.classList.add('is-closed');
    function start() {
      root.classList.remove('is-closed');
      setTimeout(function () { show(0); countK(); play(); }, 1200);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); start(); } }, { threshold: 0.25 });
      io.observe(root);
    } else start();
  }

  /* ---------- Amazon seller dashboard (Amazon hub hero) ---------- */
  function initAmzd(root) {
    if (!once(root, 'amzd')) return;
    var nums = $$('[data-g-to]', root), steps = $$('[data-amz-step]', root), count = root.querySelector('[data-amz-count]');
    function fmt(v, e) { var d = parseInt(e.getAttribute('data-g-dec') || '0', 10); return (e.getAttribute('data-g-pre') || '') + v.toFixed(d) + (e.getAttribute('data-g-suf') || ''); }
    function setK(p) { nums.forEach(function (e) { var a = +e.getAttribute('data-g-from'), b = +e.getAttribute('data-g-to'); e.textContent = fmt(a + (b - a) * p, e); }); }
    if (still) { steps.forEach(function (s) { s.classList.add('is-done'); }); root.classList.add('is-play'); return; }
    root.classList.add('is-ready'); setK(0); if (count) count.textContent = '0';
    function play() {
      root.classList.add('is-play');
      var t0 = performance.now(), D = 2200;
      (function st(t) { var p = Math.min(1, (t - t0) / D); setK(1 - Math.pow(1 - p, 3)); if (p < 1) requestAnimationFrame(st); })(t0);
      steps.forEach(function (s, i) { setTimeout(function () { s.classList.add('is-done'); if (count) count.textContent = String(i + 1); }, 900 + i * 650); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); play(); } }, { threshold: 0.3 });
      io.observe(root);
    } else play();
  }

  /* ---------- Growth flywheel (Ecommerce Marketing hub hero) ---------- */
  function initFly(root) {
    if (!once(root, 'fly')) return;
    var nodes = $$('[data-fs]', root), panes = $$('[data-fp]', root), chips = $$('[data-fc]', root);
    var toggle = root.querySelector('.wep-fly__toggle'), core = root.querySelector('.wep-fly__core');
    var n = nodes.length, step = 0, timer = null, STEP = 5000;
    var stopped = false, hovering = false, focused = false, visible = false;
    if (!n) return;
    function blocked() { return still || stopped || hovering || focused || !visible || document.hidden; }
    function set(s) {
      step = s; var i = ((s % n) + n) % n;
      root.style.setProperty('--ang', (s * 360 / n) + 'deg');
      root.style.setProperty('--c', nodes[i].getAttribute('data-c'));
      nodes.forEach(function (b, k) { b.classList.toggle('is-on', k === i); b.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      panes.forEach(function (p, k) { p.classList.toggle('is-on', k === i); p.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      chips.forEach(function (c, k) { c.classList.toggle('is-on', s > 0 && k === (i + n - 1) % n); });
    }
    function schedule() {
      clearTimeout(timer);
      if (blocked()) return;
      timer = setTimeout(function () { if (!blocked()) set(step + 1); schedule(); }, STEP);
    }
    function setStopped(v) {
      stopped = v;
      if (toggle) { toggle.textContent = v ? 'Play animation' : 'Pause animation'; toggle.setAttribute('aria-pressed', v ? 'true' : 'false'); }
      if (core) core.setAttribute('aria-live', v ? 'polite' : 'off');
      if (v) clearTimeout(timer); else schedule();
    }
    nodes.forEach(function (b, k) {
      b.addEventListener('click', function () { var i = ((step % n) + n) % n; set(step + ((k - i + n) % n)); setStopped(true); });
    });
    if (toggle) toggle.addEventListener('click', function () { setStopped(!stopped); });
    set(0);
    if (still) { root.classList.add('is-static'); return; }
    if (core) core.setAttribute('aria-live', 'off');
    root.addEventListener('mouseenter', function () { hovering = true; clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { hovering = false; schedule(); });
    root.addEventListener('focusin', function () { focused = true; clearTimeout(timer); });
    root.addEventListener('focusout', function (e) { focused = root.contains(e.relatedTarget); schedule(); });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; schedule(); }, { threshold: 0.3 }).observe(root);
    } else { visible = true; schedule(); }
  }

  /* ---------- X-ray scan ---------- */
  function initXray(root) {
    if (!once(root, 'xray')) return;
    var pdp = root.querySelector('.wep-pdp'), scan = root.querySelector('.wep-scan');
    var pins = $$('.wep-pdp .wep-pin', root), rows = $$('.wep-xi', root);
    var count = root.querySelector('[data-xr-count]'), tag = root.querySelector('[data-xr-tag]');
    var total = rows.length, DUR = 6000, x0 = performance.now();
    var tagScan = tag ? tag.getAttribute('data-scanning') || 'Scanning…' : '', tagDone = tag ? tag.getAttribute('data-done') || 'All fixed' : '';
    function draw(p) {
      if (pdp) pdp.style.setProperty('--p', Math.min(p, 1));
      var n = 0;
      pins.forEach(function (e) { e.classList.toggle('is-ok', p >= +e.getAttribute('data-y')); });
      rows.forEach(function (e) {
        var ok = p >= +e.getAttribute('data-y'); e.classList.toggle('is-ok', ok); if (ok) n++;
        var pin = e.querySelector('.wep-pin'); if (pin) pin.classList.toggle('is-ok', ok);
      });
      if (count) count.textContent = n + ' / ' + total;
      if (tag) { tag.textContent = n === total ? tagDone : tagScan; tag.classList.toggle('wep-tag--good', n === total); }
      if (scan) scan.style.opacity = p > 1 ? 0 : 1;
    }
    if (still) { draw(2); return; }
    (function tick(now) {
      if (!root.isConnected) return;
      draw(((now - x0) % (DUR + 2500)) / DUR);
      requestAnimationFrame(tick);
    })(x0);
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    if (!once(root, 'faq')) return;
    var tabs = $$('[role="tab"]', root);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var all = t.hasAttribute('data-wep-all');
        root.classList.toggle('is-all', all);
        tabs.forEach(function (x) {
          var on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-selected', on);
          if (x.hasAttribute('data-wep-all')) return;
          var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !(on || all);
        });
      });
    });
    $$('.wep-fq h4 button', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.closest('.wep-fq'), open = !q.classList.contains('is-open');
        $$('.wep-fq.is-open', root).forEach(function (x) {
          x.classList.remove('is-open'); x.querySelector('h4 button').setAttribute('aria-expanded', 'false');
        });
        q.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open);
      });
    });
  }

  /* Sticky page index (snippets/wep-jumpnav): smooth jump to each section, highlights the section being read,
     and a back-to-top button that sits above the phone action bar when that bar is showing. */
  function initJump(root) {
    if (!once(root, 'jump')) return;
    var links = $$('a[href^="#"]', root), totop = root.querySelector('.wep-totop'), hdr = document.querySelector('.wep-hdr-section');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)'), current = -1, ticking = false;
    var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
    function behavior() { return reduce.matches ? 'auto' : 'smooth'; }
    function layout() {
      /* The site header slides away on scroll down: the bar then rises to the top edge and drops back with the header. */
      var full = hdr ? hdr.offsetHeight : 0, hidden = !!document.querySelector('.wep-hdr-wrap.is-hidden'), h = hidden ? 0 : full;
      root.style.setProperty('--wep-pgnav-top', h + 'px');
      root.classList.toggle('is-top', hidden);
      /* A zoomed section (laptop screens) scales its own lengths, so the margin is divided by that zoom. */
      targets.forEach(function (t) { if (t) t.style.scrollMarginTop = ((h + root.offsetHeight + 8) / (parseFloat(getComputedStyle(t).zoom) || 1)) + 'px'; });
      return h + root.offsetHeight;
    }
    function update() {
      ticking = false;
      var line = layout() + 16, cur = -1;
      targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top <= line) cur = i; });
      if (cur !== current) {
        current = cur;
        links.forEach(function (a, i) { if (i === cur) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
        var list = cur >= 0 && links[cur].closest('ul');
        if (list && list.scrollWidth > list.clientWidth) list.scrollLeft = links[cur].offsetLeft - (list.clientWidth - links[cur].offsetWidth) / 2;
      }
      if (totop) {
        var bar = document.querySelector('.wep-mbar.is-visible');
        totop.hidden = false;
        totop.classList.toggle('is-on', window.scrollY > window.innerHeight);
        totop.classList.toggle('is-lifted', !!bar && getComputedStyle(bar).display !== 'none');
      }
    }
    function onScroll() { if (!ticking) { ticking = true; setTimeout(update, 60); } }
    links.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        var t = targets[i]; if (!t) return;
        e.preventDefault();
        layout();
        if (t.getBoundingClientRect().top > 0) t.style.scrollMarginTop = ((root.offsetHeight + 8) / (parseFloat(getComputedStyle(t).zoom) || 1)) + 'px';
        if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
        t.scrollIntoView({ behavior: behavior(), block: 'start' });
        history.replaceState(null, '', a.getAttribute('href'));
        t.focus({ preventScroll: true });
      });
    });
    if (totop) totop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: behavior() });
      var first = hdr && hdr.querySelector('a, button'); if (first) first.focus({ preventScroll: true });
    });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);
    var hdrEl = document.querySelector('.wep-hdr-wrap');
    if (hdrEl) new MutationObserver(function () { layout(); }).observe(hdrEl, { attributes: true, attributeFilter: ['class'] });
    update();
  }

  /* Migration hero background (snippets/wep-hero-paths): thin paths with dots travelling from the old store (blue) into
     Shopify (green). Paused while off screen or the tab is hidden; drawn once, still, when reduced motion is preferred. */
  function initHeroPaths(cv) {
    if (!once(cv, 'paths')) return;
    var ctx = cv.getContext('2d'), hero = cv.parentElement, W = 0, H = 0, paths = [], dots = [], running = false, raf = 0, visible = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches, phone = window.matchMedia('(max-width: 749px), (orientation: landscape) and (max-height: 500px)');
    function size() {
      var r = hero.getBoundingClientRect(), dpr = Math.min(2, window.devicePixelRatio || 1);
      W = r.width; H = r.height; cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var wide = W > 1100, x0 = wide ? W * 0.4 : W * 0.05, x1 = W * 1.02, n = wide ? 6 : 4; paths = [];
      for (var i = 0; i < n; i++) {
        var y0 = H * (0.18 + 0.12 * i), y1 = H * (0.08 + 0.17 * i);
        paths.push([x0, y0, x0 + (x1 - x0) * 0.35, y0 + H * (i % 2 ? 0.18 : -0.14), x0 + (x1 - x0) * 0.65, y1 + H * (i % 2 ? -0.12 : 0.16), x1, y1]);
      }
      dots = []; for (var k = 0; k < (wide ? 14 : 8); k++) dots.push({ p: k % paths.length, t: Math.random(), v: 0.0011 + Math.random() * 0.0013 });
    }
    function pt(c, t) { var u = 1 - t; return [u * u * u * c[0] + 3 * u * u * t * c[2] + 3 * u * t * t * c[4] + t * t * t * c[6], u * u * u * c[1] + 3 * u * u * t * c[3] + 3 * u * t * t * c[5] + t * t * t * c[7]]; }
    function mix(t) { var a = [111, 174, 245], b = [149, 191, 71]; return [0, 1, 2].map(function (i) { return Math.round(a[i] + (b[i] - a[i]) * t); }).join(','); }
    function draw() {
      ctx.clearRect(0, 0, W, H);
      paths.forEach(function (c) {
        var g = ctx.createLinearGradient(c[0], 0, c[6], 0); g.addColorStop(0, 'rgba(111,174,245,0)'); g.addColorStop(0.5, 'rgba(111,174,245,.2)'); g.addColorStop(1, 'rgba(149,191,71,.3)');
        ctx.strokeStyle = g; ctx.lineWidth = 1.2; ctx.beginPath(); ctx.moveTo(c[0], c[1]); ctx.bezierCurveTo(c[2], c[3], c[4], c[5], c[6], c[7]); ctx.stroke();
      });
      dots.forEach(function (d) {
        if (running) { d.t += d.v; if (d.t > 1) { d.t = 0; d.p = Math.floor(Math.random() * paths.length); } }
        var q = pt(paths[d.p], d.t), col = mix(d.t), a = Math.sin(Math.PI * d.t);
        ctx.fillStyle = 'rgba(' + col + ',' + (0.25 * a) + ')'; ctx.beginPath(); ctx.arc(q[0], q[1], 7, 0, 6.283); ctx.fill();
        ctx.fillStyle = 'rgba(' + col + ',' + (0.95 * a) + ')'; ctx.beginPath(); ctx.arc(q[0], q[1], 2.6, 0, 6.283); ctx.fill();
      });
      if (running) raf = requestAnimationFrame(draw);
    }
    function start() { if (running || reduce || phone.matches || !visible || document.hidden) return; running = true; raf = requestAnimationFrame(draw); }
    function stop() { running = false; cancelAnimationFrame(raf); }
    if (!phone.matches) { size(); draw(); }
    if (reduce) return;
    /* Not drawn on phones; if the window grows past that width, draw and start then. */
    phone.addEventListener('change', function () { if (phone.matches) stop(); else { size(); draw(); start(); } });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; if (visible) start(); else stop(); }).observe(hero);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    start();
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { if (!phone.matches) { size(); draw(); } }, 150); });
  }

  /* Reasons accordion (snippets/wep-reasons): one item open at a time, the open one can be closed, closed panels are inert,
     Up/Down/Home/End move between the headers. */
  function initReasons(root) {
    if (!once(root, 'reasons')) return;
    var items = $$('.wep-rsn__item', root), btns = items.map(function (it) { return it.querySelector('.wep-rsn__q button'); });
    function set(item, open) {
      var b = item.querySelector('.wep-rsn__q button'), p = item.querySelector('.wep-rsn__a');
      item.classList.toggle('is-open', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) p.removeAttribute('inert'); else p.setAttribute('inert', '');
    }
    /* Wide screens open the first item; phones and small screens start with every item closed. */
    if (window.matchMedia('(max-width: 989px)').matches) items.forEach(function (it) { set(it, false); });
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        var open = !items[i].classList.contains('is-open');
        items.forEach(function (it) { set(it, false); });
        set(items[i], open);
      });
      b.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowDown' ? i + 1 : e.key === 'ArrowUp' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? btns.length - 1 : null;
        if (n === null) return;
        e.preventDefault(); btns[(n + btns.length) % btns.length].focus();
      });
    });
  }

  /* ---------- forms → Podio lead script ---------- */
  function ensureRecaptcha() {
    if (window.grecaptcha || document.querySelector('script[src*="recaptcha/api.js"]')) return;
    var s = document.createElement('script');
    s.src = 'https://www.google.com/recaptcha/api.js'; s.async = true; s.defer = true;
    document.head.appendChild(s);
  }
  // reCAPTCHA is about 350 KB of script, so it loads when a form is close to the screen or is touched, not on every page view
  function lazyRecaptcha(form) {
    var done = false;
    function go() { if (done) return; done = true; if (io) io.disconnect(); ensureRecaptcha(); }
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) go(); }, { rootMargin: '600px 0px' });
      io.observe(form);
    }
    ['focusin', 'pointerdown', 'touchstart'].forEach(function (t) { form.addEventListener(t, go, { once: true, passive: true }); });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', mode: 'cors', headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }, body: body })
      .then(function (r) { return r.text(); });
  }
  function initForm(form) {
    if (!once(form, 'form')) return;
    if (form.querySelector('.g-recaptcha')) lazyRecaptcha(form);
    var msg = form.querySelector('.wep-form__msg');
    /* Phone: US format as you type, (555) 555-5555. Numbers that start with + are left alone. */
    function fmtUS(v) {
      if (/^\s*\+/.test(v)) return v;
      var d = v.replace(/\D/g, '');
      if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
      if (d.length > 10) return v;
      if (d.length < 4) return d;
      if (d.length < 7) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
      return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
    }
    var tel = form.querySelector('input[name="phone"]');
    if (tel) {
      tel.addEventListener('input', function () { if (tel.selectionStart === tel.value.length) tel.value = fmtUS(tel.value); });
      tel.addEventListener('blur', function () { tel.value = fmtUS(tel.value); });
      tel.value = fmtUS(tel.value);
    }
    /* The hint text inside a field goes away when the field is clicked and comes back if it is left empty. */
    form.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function (el) {
      el.setAttribute('data-ph', el.getAttribute('placeholder'));
      el.addEventListener('focus', function () { el.setAttribute('placeholder', ''); });
      el.addEventListener('blur', function () { if (!el.value) el.setAttribute('placeholder', el.getAttribute('data-ph') || ''); });
    });
    function say(t, cls) { if (!msg) return; msg.textContent = t; msg.className = 'wep-form__msg' + (cls ? ' ' + cls : ''); }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!form.checkValidity()) { form.reportValidity(); return; }
      var hp = form.querySelector('.wep-hp input'); if (hp && hp.value) return;   // spam trap
      var fd = new FormData(form);
      // Build the same fields the existing consultation form sends to Podio
      var specs = [];
      var label = form.getAttribute('data-label'); if (label) specs.push(label);
      if (fd.get('platform')) specs.push('Platform: ' + fd.get('platform'));
      if (fd.get('message')) specs.push(fd.get('message'));
      var data = new URLSearchParams();
      data.append('internal-notes', location.href + (label ? ' | ' + label : ''));
      data.append('name', fd.get('name') || String(fd.get('email') || '').split('@')[0] || 'Website lead');
      data.append('email', fd.get('email') || '');
      data.append('phone', fd.get('phone') || '');
      // Podio "Lead Name": company if the form has one, else the website's domain, else the person's name
      var site = String(fd.get('url') || '').trim().replace(/^[a-z]+:\/\//i, '').replace(/^www\./i, '').split(/[\/?#]/)[0];
      data.append('title', fd.get('company') || site || fd.get('name') || '');
      data.append('url', fd.get('url') || '');
      data.append('specs', specs.join('\n'));
      var cap = fd.get('g-recaptcha-response');
      if (form.querySelector('.g-recaptcha')) {
        if (!cap) { say(form.getAttribute('data-captcha-msg') || 'Please tick the reCAPTCHA box.', 'is-error'); return; }
        data.append('g-recaptcha-response', cap);
      }
      form.classList.add('is-loading'); say(form.getAttribute('data-sending-msg') || 'Sending…');
      var capUrl = form.getAttribute('data-captcha-url'), leadUrl = form.getAttribute('data-lead-url'), thanks = form.getAttribute('data-thanks');
      var first = capUrl ? post(capUrl, data.toString()) : Promise.resolve('ok');
      first.then(function (res) {
        if (String(res).trim() === 'error') throw new Error('captcha');
        return post(leadUrl, data.toString());
      }).then(function (res) {
        if (String(res).trim() !== 'success') throw new Error('lead');
        if (thanks) { window.location.href = thanks; return; }
        form.reset(); form.classList.remove('is-loading');
        say(form.getAttribute('data-ok-msg') || 'Thanks! We will be in touch soon.', 'is-ok');
      }).catch(function (err) {
        form.classList.remove('is-loading');
        if (window.grecaptcha && form.querySelector('.g-recaptcha')) { try { grecaptcha.reset(); } catch (x) {} }
        say(err && err.message === 'captcha' ? 'reCAPTCHA check failed. Please try again.' : 'Something went wrong. Please try again or call us.', 'is-error');
      });
    });
  }

  /* ---------- quick-quote popup links added after page load ---------- */
  function initPopupLinks(root) {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.modal) return;
    $$('a[href="#quick_quote"]', root).forEach(function (a) {
      if (!once(a, 'qq')) return;
      a.addEventListener('click', function (e) {
        if (a._wepBound) return;                       // theme script may already handle it
        e.preventDefault(); jQuery(a).modal({ fadeDuration: 250 });
      });
    });
  }


  /* ---------- scroll effects: hero parallax + process line ---------- */
  var scrollItems = [];
  var ticking = false;
  function desktop() { return window.matchMedia('(min-width: 1100px)').matches; }
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var vh = window.innerHeight;
      scrollItems.forEach(function (it) {
        if (!it.el.isConnected) return;
        var r = it.box.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;           // off screen: skip
        if (it.type === 'parallax') {
          var y = desktop() ? -r.top : 0;                          // how far the hero has scrolled up
          it.el.style.transform = y > 0 ? 'translate3d(0,' + (y * it.speed).toFixed(1) + 'px,0)' : '';
        } else {
          // progress 0→1 while the process section moves through the middle of the screen
          var p = Math.min(1, Math.max(0, (vh * 0.8 - r.top) / (r.height + vh * 0.3)));
          it.el.style.setProperty('--wep-p', p.toFixed(3));
          it.steps.forEach(function (st, i) {
            var at = it.steps.length > 1 ? i / (it.steps.length - 1) : 0;
            st.classList.toggle('is-active', p >= at - 0.001);
          });
        }
      });
    });
  }
  function initScroll(root) {
    if (still || document.documentElement.classList.contains('shopify-design-mode')) return;
    $$('[data-wep-speed]', root).forEach(function (el) {
      if (!once(el, 'px')) return;
      var box = el.closest('.wep') || el;
      scrollItems.push({ type: 'parallax', el: el, box: box, speed: parseFloat(el.getAttribute('data-wep-speed')) || 0 });
    });
    $$('[data-wep-process]', root).forEach(function (el) {
      if (!once(el, 'proc')) return;
      el.classList.add('is-live');
      scrollItems.push({ type: 'process', el: el, box: el, steps: $$('.wep-pstep', el) });
    });
    if (scrollItems.length && !window._wepScrollBound) {
      window._wepScrollBound = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
    }
    onScroll();
  }


  /* ---------- reviews: scroll-snap track, arrows, dots, read more ---------- */
  function initReviews(root) {
    if (!once(root, 'rv')) return;
    var track = root.querySelector('.wep-rv-track'); if (!track) return;
    var cards = $$('.wep-rvc', track), prev = root.querySelector('.wep-rv-prev'), next = root.querySelector('.wep-rv-next'), dots = root.querySelector('.wep-rv-dots');
    function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; }
    function perView() { return Math.max(1, Math.round(track.clientWidth / step())); }
    function pages() { return Math.max(1, cards.length - perView() + 1); }
    function index() { return Math.round(track.scrollLeft / step()); }
    function draw() {
      var n = pages(), i = Math.min(index(), n - 1);
      if (dots.children.length !== n) { dots.innerHTML = ''; for (var k = 0; k < n; k++) dots.appendChild(document.createElement('i')); }
      [].forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); });
      prev.disabled = i <= 0; next.disabled = i >= n - 1;
      root.querySelector('.wep-rv-nav').hidden = n < 2;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: still ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: still ? 'auto' : 'smooth' }); });
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(draw, 60); }, { passive: true });
    window.addEventListener('resize', draw);
    cards.forEach(function (c) {
      var p = c.querySelector('.wep-rvc__text p'), btn = c.querySelector('.wep-rvc__more');
      if (!p || !btn) return;
      function check() { if (!c.classList.contains('is-open')) btn.hidden = p.scrollHeight <= p.clientHeight + 2; }
      check(); window.addEventListener('resize', check);
      btn.addEventListener('click', function () {
        var open = !c.classList.contains('is-open'); c.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open); btn.textContent = open ? 'Show less' : (btn.getAttribute('data-more') || btn.textContent);
      });
      btn.setAttribute('data-more', btn.textContent);
    });
    draw();
  }


  /* ---------- Amazon SEO: free title checker ---------- */
  function initTchk(root) {
    if (!once(root, 'tchk')) return;
    var t = root.querySelector('[data-tchk="title"]'), h = root.querySelector('[data-tchk="hl"]'), br = root.querySelector('[data-tchk="brand"]');
    var ct = root.querySelector('[data-tchk-count="title"]'), ch = root.querySelector('[data-tchk-count="hl"]'), sum = root.querySelector('[data-tchk-sum]');
    var BANNED = /[!$?_{}^¬¦]/g;
    var SMALL = ['a', 'an', 'the', 'and', 'or', 'but', 'nor', 'for', 'of', 'to', 'in', 'on', 'at', 'by', 'with', 'from', 'as', 'into', 'over', 'per', '&'];
    var PROMO = ['free shipping', 'best seller', 'bestseller', 'best selling', 'hot sale', 'sale', 'on sale', 'deal', 'discount', 'limited time', 'cheap', 'guaranteed', 'guarantee', '100% quality', 'top rated', 'top-rated', 'best', 'free gift', 'gift idea', 'new arrival', 'clearance', 'buy now', 'amazon\'s choice', 'brand new'];
    var fails = 0, warns = 0;
    function rule(k, ok, msg) {
      var li = root.querySelector('[data-tchk-rule="' + k + '"]'), w = li.getAttribute('data-kind') === 'warn';
      li.classList.toggle('is-ok', ok); li.classList.toggle('is-bad', !ok && !w); li.classList.toggle('is-warn', !ok && w);
      li.querySelector('[data-tchk-msg]').textContent = msg;
      if (!ok) { if (w) warns++; else fails++; }
      return 0;
    }
    function stem(w) { w = w.replace(/('|’)s$/, ''); return (w.length > 3 && /[^s]s$/.test(w)) ? w.slice(0, -1) : w; }
    function run() {
      var title = t.value.trim(), hl = h.value.trim(), bad = 0, n = title.length, lc = title.toLowerCase();
      fails = 0; warns = 0;
      var brand = (br && br.value.trim()) || '', bl = brand.toLowerCase(), bw = bl.split(/\s+/).filter(Boolean);
      var rest = brand ? title.split(brand).join(' ') : title;
      ct.textContent = n; ch.textContent = hl.length;
      ct.parentNode.classList.toggle('is-over', n > 75); ch.parentNode.classList.toggle('is-over', hl.length > 125);
      bad += rule('len', n > 0 && n <= 75, n === 0 ? 'Enter a title to check it.' : n <= 75 ? n + ' characters. Good.' : n + ' characters: ' + (n - 75) + ' over. Move details into Item Highlights.');
      var bc = (rest.match(BANNED) || []).filter(function (c, i, a) { return a.indexOf(c) === i; });
      bad += rule('chars', !bc.length, bc.length ? 'Found: ' + bc.join(' ') + '. Not allowed outside a brand name.' : 'None found.');
      var words = rest.toLowerCase().replace(/[^a-z0-9’'\s-]/g, ' ').split(/[\s-]+/).filter(function (w) { return w && SMALL.indexOf(w) < 0 && bw.indexOf(w) < 0; });
      var cnt = {}; words.forEach(function (w) { var s = stem(w); cnt[s] = (cnt[s] || 0) + 1; });
      var rep = Object.keys(cnt).filter(function (k) { return cnt[k] > 2; });
      bad += rule('repeat', !rep.length, rep.length ? 'Used 3+ times: ' + rep.map(function (k) { return '“' + k + '” ×' + cnt[k]; }).join(', ') + '. Amazon allows a word twice.' : 'No word used more than twice.');
      var pr = PROMO.filter(function (p) { return new RegExp('(^|[^a-z])' + p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '($|[^a-z])').test(lc); });
      pr = pr.filter(function (p) { return !pr.some(function (q) { return q !== p && q.indexOf(p) >= 0; }); });
      bad += rule('promo', !pr.length, pr.length ? 'Found: ' + pr.map(function (p) { return '“' + p + '”'; }).join(', ') + '. Remove unless it’s a factual product detail.' : 'None found.');
      var caps = (rest.match(/\b[A-Z]{4,}\b/g) || []).filter(function (w, i, a) { return a.indexOf(w) === i && bw.indexOf(w.toLowerCase()) < 0; });
      bad += rule('caps', !caps.length, caps.length ? 'Found: ' + caps.join(', ') + '. Fine if it’s a brand or model name; otherwise use normal capitalization.' : 'None found.');
      bad += rule('hl', hl.length <= 125, hl.length ? hl.length + ' characters.' + (hl.length > 125 ? ' ' + (hl.length - 125) + ' over.' : ' Good.') : 'Empty. Use it for materials, uses or compatibility.');
      sum.textContent = n === 0 ? 'Enter a title' : (!fails && !warns) ? 'Looks good' : [fails ? fails + (fails === 1 ? ' fail' : ' fails') : '', warns ? warns + ' to review' : ''].filter(Boolean).join(' · ');
      root.classList.toggle('is-clean', n > 0 && !fails && !warns);
    }
    t.addEventListener('input', run); h.addEventListener('input', run); if (br) br.addEventListener('input', run);
    run();
  }
  /* ---------- Amazon SEO: product page makeover (hero) ---------- */
  function initPdp(root) {
    if (!once(root, 'pdp')) return;
    var tabs = $$('[data-pdp-tab]', root), cos = $$('[data-pdp-co]', root), ks = $$('[data-pdp-k]', root), mix = root.querySelector('[data-pdp-mix]');
    var timers = [], played = false, N = cos.length;
    function zone(i) { return root.querySelector('[data-pdp-z="' + i + '"]'); }
    function setK(p) {
      ks.forEach(function (k) { var a = +k.getAttribute('data-from'), b = +k.getAttribute('data-to'), d = +(k.getAttribute('data-dec') || 0); k.textContent = (a + (b - a) * p).toFixed(d) + k.getAttribute('data-suf'); });
      if (mix) mix.style.width = (30 + 35 * p) + '%';
    }
    function clear() { timers.forEach(clearTimeout); timers = []; }
    function show(state, instant) {
      clear();
      var after = state === 'after';
      root.classList.toggle('is-after', after); root.classList.toggle('is-before', !after);
      tabs.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-pdp-tab') === state ? 'true' : 'false'); });
      if (!after || instant) {
        cos.forEach(function (c, i) { c.classList.toggle('is-done', after); c.classList.remove('is-pop'); var z = zone(i); if (z) z.classList.toggle('is-done', after); });
        setK(after ? 1 : 0); return;
      }
      cos.forEach(function (c) { c.classList.remove('is-done'); }); setK(0);
      cos.forEach(function (c, i) {
        timers.push(setTimeout(function () {
          c.classList.add('is-done', 'is-pop'); var z = zone(+c.getAttribute('data-pdp-co')); if (z) z.classList.add('is-done');
          setK((i + 1) / N);
          timers.push(setTimeout(function () { c.classList.remove('is-pop'); }, 300));
        }, 300 + i * 450));
      });
    }
    tabs.forEach(function (b) { b.addEventListener('click', function () { played = true; show(b.getAttribute('data-pdp-tab'), false); }); });
    if (still) { show('after', true); return; }
    show('before', true);
    function play() { if (played) return; played = true; timers.push(setTimeout(function () { show('after', false); }, 2200)); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); play(); } }, { threshold: 0.3 });
      io.observe(root);
    } else play();
  }

  /* ---------- Amazon SEO: organic flywheel ---------- */
  function initLoop(root) {
    if (!once(root, 'loop')) return;
    var ns = $$('[data-loop-n]', root), i = 0, t = null;
    function step() { ns.forEach(function (n) { n.classList.remove('is-on'); }); ns[i].classList.add('is-on'); i = (i + 1) % ns.length; }
    if (still) { root.classList.add('is-paused'); return; }
    function start() { if (!t) { step(); t = setInterval(step, 2000); root.classList.remove('is-paused'); } }
    function stop() { clearInterval(t); t = null; root.classList.add('is-paused'); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { en[0].isIntersecting ? start() : stop(); }, { threshold: 0.2 }).observe(root);
    } else start();
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : null; });
  }

  /* ---------- A+ Content & Storefront builder (hero) ---------- */
  function initAbx(root) {
    if (!once(root, 'abx')) return;
    var tabs = $$('[data-abx-tab]', root), panes = $$('[data-abx-pane]', root), url = root.querySelector('[data-abx-url]');
    var URLS = { aplus: 'amazon.com/dp/B0HYDRO32 · From the brand', store: 'amazon.com/stores/HydroPeak' };
    var timers = [], played = false;
    function clear() { timers.forEach(clearTimeout); timers = []; }
    function show(k, animate) {
      clear();
      tabs.forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-abx-tab') === k ? 'true' : 'false'); });
      panes.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-abx-pane') === k); });
      if (url) url.textContent = URLS[k];
      var pane = root.querySelector('[data-abx-pane="' + k + '"]'), items = $$('[data-abx-m], [data-abx-t]', pane);
      if (!animate) { items.forEach(function (e) { e.classList.add('is-in'); }); return; }
      items.forEach(function (e) { e.classList.remove('is-in'); });
      items.forEach(function (e, i) { timers.push(setTimeout(function () { e.classList.add('is-in'); }, 250 + i * (k === 'aplus' ? 550 : 260))); });
      return 250 + items.length * (k === 'aplus' ? 550 : 260);
    }
    tabs.forEach(function (b) { b.addEventListener('click', function () { played = true; show(b.getAttribute('data-abx-tab'), !still); }); });
    if (still) { show('aplus', false); return; }
    root.classList.add('is-ready');
    function play() {
      if (played) return; played = true;
      var d = show('aplus', true);
      timers.push(setTimeout(function () { show('store', true); }, d + 2600));
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); play(); } }, { threshold: 0.3 });
      io.observe(root);
    } else play();
  }

  /* ---------- A+ rule check ---------- */
  function initArc(root) {
    if (!once(root, 'arc')) return;
    var ta = root.querySelector('[data-arc="text"]'), cnt = root.querySelector('[data-arc-count]'), sum = root.querySelector('[data-arc-sum]');
    var RULES = {
      price: /(\$\s?\d[\d.,]*|\b\d+\s?%\s?off\b|\bsale\b|\bdiscount\w*|\bdeals?\b|\bcoupons?\b|\bfree shipping\b|\bcheapest\b|\blimited[- ]time\b|\bfree gift\b|\bbuy one\b)/gi,
      contact: /(https?:\/\/\S+|\bwww\.[^\s,]+|\b[\w.-]+@[\w-]+\.\w+|\b[\w-]+\.(com|net|org|co|io|shop)\b|\(?\b\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}\b)/gi,
      rival: /(\bunlike (other|most|competing)\b[^.,!?]*|\bbetter than\b|\bcompared to\b|\bvs\.?(?=\s)|\bother brands\b|\bcompetitors?\b)/gi,
      warranty: /(\bguarantee\w*|\bwarrant(y|ies)\b|\bmoney[- ]back\b|\b100%\s?satisf\w*)/gi,
      rating: /(#\s?1\b|\bnumber one\b|\bbest[- ]?sell\w*|\btop[- ]rated\b|\bhighest[- ]rated\b|\b5[- ]star\w*)/gi,
      eco: /(\beco[- ]?friendly\b|\bbiodegradable\b|\bcompostable\b|\benvironmentally friendly\b|\bgreen product\b)/gi,
      proof: /(\bcertified\b|\bproven\b|\baward[- ]winning\b|\bpatented\b|\bclinically\b|\blab[- ]tested\b)/gi,
      health: /(\bcures?\b|\bheals?\b|\bdisease\w*|\bFDA[- ]approved\b|\banti[- ]?(bacterial|viral)\b|\b(prevents?|treats?|relieves?)\b(?=\s+(?:\w+\s+){0,2}(illness\w*|infections?|pain|disease\w*|cancer|virus\w*|bacteria|conditions?|symptoms?|anxiety|acne|arthritis|insomnia|allerg\w*)))/gi
    };
    function run() {
      var text = ta.value, words = (text.trim().match(/\S+/g) || []).length, f = 0, w = 0;
      cnt.textContent = words;
      Object.keys(RULES).forEach(function (k) {
        var li = root.querySelector('[data-arc-rule="' + k + '"]'), warn = li.getAttribute('data-kind') === 'warn';
        var m = (text.match(RULES[k]) || []).map(function (x) { return x.trim(); }), low = m.map(function (y) { return y.toLowerCase(); });
        m = m.filter(function (x, i) { return x && low.indexOf(x.toLowerCase()) === i; });
        li.classList.toggle('is-ok', !m.length); li.classList.toggle('is-bad', !!m.length && !warn); li.classList.toggle('is-warn', !!m.length && warn);
        li.querySelector('[data-arc-msg]').textContent = m.length ? 'Found: ' + m.slice(0, 4).map(function (x) { return '“' + x + '”'; }).join(', ') + (m.length > 4 ? '…' : '') : 'None found.';
        if (m.length) { if (warn) w++; else f++; }
      });
      sum.textContent = !words ? 'Paste your text' : (!f && !w) ? 'No common text flags found' : f + ' not allowed · ' + w + ' to review';
      root.classList.toggle('is-clean', words > 0 && !f && !w);
    }
    ta.addEventListener('input', run); run();
  }


  /* ---------- Product research hero: sample report ---------- */
  function initPrx(root) {
    if (!once(root, 'prx')) return;
    var data; try { data = JSON.parse(root.querySelector('[data-prx-json]').textContent); } catch (e) { return; }
    var tabs = $$('[data-prx-tab]', root), pane = root.querySelector('[data-prx-pane]');
    var f = {}; $$('[data-prx]', root).forEach(function (el) { f[el.getAttribute('data-prx')] = el; });
    var funnel = $$('[data-prx-f]', root), timers = [], cur = 0, auto = true;
    function clear() { timers.forEach(clearTimeout); timers = []; }
    function fill(d) {
      f.name.textContent = d.name; f.cat.textContent = d.cat; f.searches.textContent = d.searches; f.reviews.textContent = d.reviews;
      f.margin.textContent = d.margin; f.tl.textContent = d.tl; f.price.textContent = d.price; f.why.textContent = d.why;
      f.verdict.textContent = d.vt; f.verdict.className = 'wep-prx__verdict is-' + d.v;
      f.bar.innerHTML = d.bar; f.leg.innerHTML = d.leg; f.trend.setAttribute('d', d.trend);
    }
    function draw() {
      if (still) return;
      var line = f.trend; line.classList.add('is-draw');
      requestAnimationFrame(function () { requestAnimationFrame(function () { line.classList.remove('is-draw'); }); });
    }
    function show(k, animate) {
      cur = k;
      tabs.forEach(function (b, i) { b.setAttribute('aria-selected', i === k ? 'true' : 'false'); b.tabIndex = i === k ? 0 : -1; });
      if (!animate || still) { fill(data[k]); return; }
      pane.classList.add('is-swap');
      setTimeout(function () { fill(data[k]); pane.classList.remove('is-swap'); draw(); }, 280);
    }
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { auto = false; clear(); show(i, true); });
      b.addEventListener('keydown', function (e) {
        var n = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!n) return;
        e.preventDefault(); var j = (cur + n + tabs.length) % tabs.length; auto = false; clear(); show(j, true); tabs[j].focus();
      });
    });
    show(0, false);
    if (still) { funnel.forEach(function (el) { el.classList.add('is-in'); }); return; }
    root.classList.add('is-ready');
    function play() {
      funnel.forEach(function (el, i) {
        timers.push(setTimeout(function () {
          el.classList.add('is-in');
          var n = el.querySelector('[data-prx-n]'); tween(n, 0, +n.getAttribute('data-prx-n'), 700);
        }, 200 + i * 450));
      });
      var t = 200 + funnel.length * 450 + 300;
      timers.push(setTimeout(draw, t));
      [1, 2, 0].forEach(function (k, i) { timers.push(setTimeout(function () { if (auto) show(k, true); }, t + 3400 * (i + 1))); });
    }
    if ('IntersectionObserver' in window) {
      var ob = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { ob.disconnect(); play(); } }, { threshold: 0.3 });
      ob.observe(root);
    } else play();
  }

  /* ---------- panels: reveal rows one by one ---------- */
  function initSeq(root) {
    if (!once(root, 'seq') || still) return;
    var items = $$('[data-seq]', root);
    root.classList.add('wep-seq-anim', 'is-ready');
    function go() { items.forEach(function (el, i) { setTimeout(function () { el.classList.add('is-in'); }, 150 + i * 220); }); }
    if ('IntersectionObserver' in window) {
      var ob = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { ob.disconnect(); go(); } }, { threshold: 0.25 });
      ob.observe(root);
    } else go();
  }

  /* ---------- profit calculator ---------- */
  function initPrc(root) {
    if (!once(root, 'prc')) return;
    var inp = {}; $$('[data-pc]', root).forEach(function (i) { inp[i.getAttribute('data-pc')] = i; });
    var out = {}; $$('[data-pc-out]', root).forEach(function (o) { out[o.getAttribute('data-pc-out')] = o; });
    var fillEl = root.querySelector('[data-pc-fill]'), warn = root.querySelector('[data-pc-warn]');
    function num(k) { var v = parseFloat(inp[k] && inp[k].value); return isFinite(v) && v > 0 ? v : 0; }
    function pct(v) { return Math.round(v) + '%'; }
    function money(v) { return (v < 0 ? '−$' : '$') + Math.abs(v).toFixed(2); }
    function calc() {
      var price = num('price'), cost = num('cost'), fees = num('fees'), ads = num('ads'), other = num('other');
      var net = price - cost - fees - ads - other, before = price - cost - fees - other;
      var margin = price > 0 ? net / price * 100 : 0;
      out.margin.textContent = price > 0 ? pct(margin) : '—';
      out.net.textContent = money(net);
      out.roi.textContent = cost > 0 ? pct(net / cost * 100) : '—';
      out.acos.textContent = price > 0 ? pct(Math.max(0, before / price * 100)) : '—';
      var bad = price > 0 && net < 0, thin = !bad && margin < 15;
      out.verdict.textContent = !price ? '—' : bad ? 'Loses money' : thin ? 'Thin margin' : 'Room to work with';
      out.hint.textContent = !price ? 'Enter a selling price.' : bad ? 'Every sale loses money at these numbers.' : thin ? 'Little room for price drops, coupons or extra ad spend.' : 'There’s room for price tests, coupons and launch ads.';
      if (warn) warn.hidden = !bad;
      root.classList.toggle('is-bad', bad); root.classList.toggle('is-thin', thin);
      if (fillEl) fillEl.style.width = Math.max(0, Math.min(100, margin * 2)) + '%';
    }
    Object.keys(inp).forEach(function (k) { inp[k].addEventListener('input', calc); });
    calc();
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    $$('[data-wep-demo]', root).forEach(initDemo);
    $$('[data-wep-stc]', root).forEach(initStc);
    $$('[data-wep-beacos]', root).forEach(initBeacos);
    $$('[data-wep-xray]', root).forEach(initXray);
    $$('[data-wep-tchk]', root).forEach(initTchk);
    $$('[data-wep-apdp]', root).forEach(initPdp);
    $$('[data-wep-loop]', root).forEach(initLoop);
    $$('[data-wep-abx]', root).forEach(initAbx);
    $$('[data-wep-arc]', root).forEach(initArc);
    $$('[data-wep-prx]', root).forEach(initPrx);
    $$('[data-wep-seq]', root).forEach(initSeq);
    $$('[data-wep-prc]', root).forEach(initPrc);
    $$('[data-wep-ai]', root).forEach(initAi);
    $$('[data-wep-growth]', root).forEach(initGrowth);
    $$('[data-wep-meta]', root).forEach(initMeta);
    $$('[data-wep-ba]', root).forEach(initBA);
    $$('[data-wep-hl]', root).forEach(initHL);
    $$('[data-wep-fly]', root).forEach(initFly);
    $$('[data-wep-amzd]', root).forEach(initAmzd);
    $$('[data-wep-env]', root).forEach(initEnv);
    initScroll(root);
    $$('[data-wep-faq]', root).forEach(initFaq);
    $$('[data-wep-jump]', root).forEach(initJump);
    $$('[data-wep-paths]', root).forEach(initHeroPaths);
    $$('[data-wep-reasons]', root).forEach(initReasons);
    $$('[data-wep-reviews]', root).forEach(initReviews);
    $$('form[data-wep-form]', root).forEach(initForm);
    if (document.querySelector('.wep-mbar')) document.body.classList.add('wep-has-mbar');
    if (root !== document) initPopupLinks(root);
  }

  window.WEPSections = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* Hero fit: scale the hero content so the whole hero is exactly one screen tall (desktop). */
(function () {
  'use strict';
  var timer;
  function fit() {
    var grid = document.querySelector('.wep-hero__grid');
    if (!grid) return;
    grid.style.zoom = '';
    if (!window.matchMedia('(min-width: 1100px)').matches) return;
    var hero = grid.closest('.wep-s-hero');
    var cs = getComputedStyle(hero);
    var avail = window.innerHeight - parseFloat(cs.paddingTop) - parseFloat(cs.paddingBottom);
    var natural = grid.getBoundingClientRect().height;
    if (!natural || avail <= 0) return;
    var z = Math.max(0.55, Math.min(1, avail / natural));
    if (z < 1) grid.style.zoom = z.toFixed(3);
  }
  function later() { clearTimeout(timer); timer = setTimeout(fit, 120); }
  window.addEventListener('resize', later);
  window.addEventListener('load', function () { fit(); setTimeout(fit, 400); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  if (document.readyState !== 'loading') fit(); else document.addEventListener('DOMContentLoaded', fit);
})();
